import { computed, ref } from "vue";

const openedType = ref<string | null>(null);
export const usePackageManager = () => {
  const openSMS = () => (openedType.value = "sms");
  const openWhatsapp = () => (openedType.value = "whatsapp");
  
  const isOpenSms = computed(() => openedType.value === "sms");
  const isOpenWhatsapp = computed(() => openedType.value === "whatsapp");

  const close = () => {
    openedType.value = null;
  };

  return {
    openedType,
    openSMS,
    openWhatsapp,
    isOpenSms,
    close,
    isOpenWhatsapp,
  };
};
